import { WorkingDaysModel } from "client/Api/UserProfile/service";
import { DayOfWeek } from "client/DateAndTime/culture";
import { DateOnly } from "client/DateAndTime/dateOnly";
import {
	getDayOfWeek
} from "client/DateAndTime/dateUtils";

export function generateWorkWeekDateArray(
	weekDays: readonly DateOnly[],
	workingDays: WorkingDaysModel
): readonly DateOnly[] {
	const {
		sunday,
		monday,
		tuesday,
		wednesday,
		thursday,
		friday,
		saturday
	} = workingDays;

	const days: DayOfWeek[] = [
		[DayOfWeek.Sunday, sunday],
		[DayOfWeek.Monday, monday],
		[DayOfWeek.Tuesday, tuesday],
		[DayOfWeek.Wednesday, wednesday],
		[DayOfWeek.Thursday, thursday],
		[DayOfWeek.Friday, friday],
		[DayOfWeek.Saturday, saturday]
	].filter(
		x => x[1]
	).map(
		x => x[0] as DayOfWeek
	);

	const defaultWorkingDays = [
		DayOfWeek.Monday,
		DayOfWeek.Tuesday,
		DayOfWeek.Wednesday,
		DayOfWeek.Thursday,
		DayOfWeek.Friday
	];

	return getWorkWeek(
		weekDays,
		days.length > 0
			? days
			: defaultWorkingDays
	);
}

function getWorkWeek(
	weekDays: readonly DateOnly[],
	workingDays: readonly DayOfWeek[]
): readonly DateOnly[] {
	const result: DateOnly[] = [];

	for (const day of weekDays) {
		const dayOfWeek: DayOfWeek = getDayOfWeek(day);

		if (workingDays.includes(dayOfWeek)) {
			result.push(day);
		}
	}

	return result;
}